import { safeEnv } from '@shared/lib';

export const AUTH_QUERY_KEY = 'auth';
export const AUTH_TENANT = safeEnv.VITE_AUTH_TENANT;
export const AUTH_MFA_TYPE = 'email';
export const AUTH_OTP_LENGTH = 6;
